export default "__VITE_ASSET__DJCWstGj__"